import { render, staticRenderFns } from "./SectionRosterRow.vue?vue&type=template&id=22587bab&scoped=true"
import script from "./SectionRosterRow.vue?vue&type=script&lang=js"
export * from "./SectionRosterRow.vue?vue&type=script&lang=js"
import style0 from "./SectionRosterRow.vue?vue&type=style&index=0&id=22587bab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22587bab",
  null
  
)

export default component.exports